import TransactionDetailsContent from './components/TransactionDetails.Content';
import TransactionDetailsRow from './components/TransactionDetails.Row';
import TransactionDetailsRowLeft from './components/TransactionDetails.RowLeft';
import TransactionDetailsRowRight from './components/TransactionDetails.RowRight';

export const TransactionDetails = {
	Content: TransactionDetailsContent,
	Row: TransactionDetailsRow,
	RowLeft: TransactionDetailsRowLeft,
	RowRight: TransactionDetailsRowRight,
};
